import { render, staticRenderFns } from "./NavigateUp.vue?vue&type=template&id=6fc97b20&scoped=true&"
import script from "./NavigateUp.vue?vue&type=script&lang=js&"
export * from "./NavigateUp.vue?vue&type=script&lang=js&"
import style0 from "./NavigateUp.vue?vue&type=style&index=0&id=6fc97b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc97b20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
